import React from 'react'
import gql from 'graphql-tag'
import styled from '@emotion/styled'
import { withTranslation } from '../../i18n'
import { Mutation } from '@apollo/react-components'
import {
  Dialog,
  DialogWindow,
  DialogHeader,
  DialogBody,
  Button,
  space,
} from '@ticketswap/solar'
import { createMarkup, track, resetTrackingIdentity } from '../../utils'
import {
  TERMS_PRIVACY_CONSENT_VIEWED,
  TERMS_PRIVACY_CONSENT_ACCEPTED,
  TERMS_PRIVACY_CONSENT_REJECTED,
} from '~/lib/tracking-events'
import { useViewer } from '../ViewerContext'
import cookies from 'js-cookie'
import { useMutation } from '@apollo/react-hooks'

const INVALIDATE_ACCESS_TOKEN = gql`
  mutation invalidateAccessToken {
    invalidateAccessToken {
      successfullyLoggedOut
    }
  }
`

export const AGREE_WITH_TERMS_AND_PRIVACY_POLICY = gql`
  mutation agreeWithTermsAndPrivacyPolicy {
    AgreeWithTermsAndPrivacyPolicy {
      user {
        id
        hasAgreedToLatestTermsAndPrivacyPolicy
      }
      errors {
        key
        message
        code
      }
    }
  }
`

const Container = styled.div`
  display: grid;
  grid-gap: ${space[8]};
  margin-top: ${space[32]};
`

const ConsentDialog = ({ t }) => {
  const { viewer, resetViewer } = useViewer()
  const [invalidateAccessToken] = useMutation(INVALIDATE_ACCESS_TOKEN)

  return (
    <Dialog
      defaultOn={viewer && !viewer.hasAgreedToLatestTermsAndPrivacyPolicy}
      onToggle={on => on && track(TERMS_PRIVACY_CONSENT_VIEWED)}
      persist
    >
      {({ hide, getWindowProps }) => (
        <DialogWindow {...getWindowProps()}>
          <DialogHeader>{t('consent.title')}</DialogHeader>
          <Mutation mutation={AGREE_WITH_TERMS_AND_PRIVACY_POLICY}>
            {(agree, { loading }) => (
              <DialogBody>
                <p
                  style={{ textAlign: 'center' }}
                  dangerouslySetInnerHTML={createMarkup(t('consent.info'), {
                    renderInline: true,
                  })}
                />
                <Container>
                  <Button
                    variant="success"
                    loading={loading}
                    onClick={async () => {
                      track(TERMS_PRIVACY_CONSENT_ACCEPTED)
                      await agree()
                      hide()
                    }}
                  >
                    {t('consent.buttons.agree')}
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={async () => {
                      resetViewer()
                      track(TERMS_PRIVACY_CONSENT_REJECTED)
                      hide()
                      await invalidateAccessToken()
                      cookies.remove('token')
                      resetTrackingIdentity()
                    }}
                  >
                    {t('consent.buttons.decline')}
                  </Button>
                </Container>
              </DialogBody>
            )}
          </Mutation>
        </DialogWindow>
      )}
    </Dialog>
  )
}

export default withTranslation('common')(ConsentDialog)
